import lcMosaic from '../../assets/lc-mosaic.svg'

export const AboutPage = () => (
	<div className="px-6 md:px-12 py-16 md:py-24">
		<div className="grid grid-cols-1 md:grid-cols-[1fr_280px] gap-12 md:gap-16 max-w-[1600px] mx-auto">

			{/* Left — prose */}
			<div className="text-left">
				<p className="font-mono uppercase text-[11px] tracking-widest text-ink-2 mb-4 border border-ink inline-block px-2 py-1">
					About · The Editor's Page
				</p>
				<h1 className="font-display font-extrabold text-[clamp(48px,6vw,96px)] leading-none text-ink mb-8">
					<span className="uppercase">
						The{' '}
						<span className="bg-hazard">longer</span>
					</span>
					<br />
					<span className="font-serif italic font-normal normal-case">version.</span>
				</h1>
				<div className="font-serif text-[18px] leading-relaxed text-ink space-y-5">
					<p>
						I'm Luiz. I grew up between two languages and a continent that wasn't this one, and somewhere along the way ended up in Sydney with a football kit, a well-loved skateboard, a snowboard waiting for season, a 4x4 for getting properly away, and a reasonable inbox.
					</p>
					<p>
						I work at <span className="bg-hazard px-[3px]">Nine</span>, in the publishing division. Engineering manager. Before that, eleven years building things in code — React, Node, the usual tools — though I'd rather talk about the editorial side: the people writing the words on the other end of those pipelines.
					</p>
					<p>
						I think a lot about <span className="bg-hazard px-[3px]">craft</span>. I think it's underrated in software, and overrated in the way it's usually performed. I'd rather see the work than read about the work.
					</p>
					<p className="text-[15px] font-serif italic text-ink-dim border-l-2 border-hot pl-4 py-1">
						A note on the achievements page that used to live here: I took it down. Most of what I do isn't visible, and the visible things were starting to feel like they were doing the talking.
					</p>
					<p>
						Outside of all that, I'm uncomplicated. Saturday morning football. Skateboard sessions on the way home from work. Snowboard trips when the southern season opens. The 4x4 out when I need to escape the noise. Sunday breakfast, slow.
					</p>
					<p>
						If we should talk — about engineering leadership, publishing systems, or where to camp in Great Sandy NP up near Noosa — the door is open.
					</p>
				</div>
			</div>

			{/* Right — about-card */}
			<aside className="sticky top-24 self-start border border-ink p-5">
				<img src={lcMosaic} alt="" className="w-20 h-20 mb-8" />
				<dl className="grid grid-cols-[auto_1fr] gap-x-6 gap-y-3 font-mono text-[11px] uppercase">
					<dt className="text-ink-2 font-medium">Name</dt>
					<dd className="text-ink font-bold">Luiz Cavalieri</dd>

					<dt className="text-ink-2 font-medium">Role</dt>
					<dd className="text-ink font-bold">
						Eng. Mgr.<br />
						<em className="font-serif normal-case not-italic italic">Nine · Publishing</em>
					</dd>

					<dt className="text-ink-2 font-medium">Tenure</dt>
					<dd className="text-ink font-bold">
						11 yrs software<br />
						4 yrs leading
					</dd>

					<dt className="text-ink-2 font-medium">Locale</dt>
					<dd className="text-ink font-bold">Sydney · NSW</dd>

					<dt className="text-ink-2 font-medium">Off hours</dt>
					<dd className="text-ink font-bold">Football · Skate · Snow</dd>

					<dt className="text-ink-2 font-medium">Reading</dt>
					<dd className="text-ink font-bold">
						<em className="font-serif normal-case not-italic italic">Tracks</em>
					</dd>
				</dl>
			</aside>

		</div>
	</div>
)

export default AboutPage
